import TrackingAnchor from "./TrackingAnchor";
import { types } from "./definitions";

export default TrackingAnchor;
export { types as trackingAnchorTypes };
